import { createRouter, createWebHashHistory } from 'vue-router'
import VMeasures from "../views/VMeasures.vue";
import VSubPlacement  from "../views/VSubPlacement.vue";
import VHome from "../views/VHome.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: VHome
  },
  {
    path: '/room',
    name: 'room',
    component: VSubPlacement
  },
  {
    path: '/measures',
    name: 'measures',
    component: VMeasures
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/' // Redirige vers la route "machines"
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router
